<div *ngIf="loader" class="loader-container">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="container-fluid p-3" *ngIf="!loader">
  <!-- No Notify Order Message -->
  <div *ngIf="notifyList.length === 0" class="text-center">
    <div class="col-md-12 text-center py-5">
      <div class=" p-3">
        <h2 class="bouncing-text text-danger">No Notify Orders !!</h2>
      </div>
    </div>
  </div>

  <!-- Notify Order List -->
  <div *ngFor="let details of notifyList; let i = index" class="mb-3">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">{{ details.brand }} {{ details.modelNumber }}</h5>
        <h6 *ngIf="details.color" class="card-subtitle mb-2 text-muted">Color: {{ details.color }}</h6>
        <p *ngIf="details.color" class="card-text">
          This item is currently not in stock with Brand/ND. The current availability is in:
        </p>

        <!-- Color Change Buttons -->
        <div *ngFor="let item of details.customNotifyItem" class="mb-2">
          <button pButton type="button" label="Change color to {{ item.color }}" class="btn btn-secondary"
                  (click)="openModal(colorChangeTemplate, details.orderId, item.itemId)"></button>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex gap-2">
          <button pButton type="button" label="Cancel Order" class="btn btn-danger"
                  (click)="openModal(confirmTemplate, details.orderId)"></button>
          <button pButton type="button" label="Hold Order" class="btn btn-primary"
                  (click)="openModal(holdTemplate, details.orderId)"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmation Modal for Cancel Order -->
<p-dialog header="Confirm Cancellation" [(visible)]="displayCancelModal" [modal]="true" [style]="{ width: '400px' }">
  <p>Are you sure you want to cancel the order?</p>
  <div class="d-flex justify-content-end gap-2">
    <button pButton type="button" label="Cancel" class="btn btn-secondary" (click)="displayCancelModal = false"></button>
    <button pButton type="button" label="Confirm" class="btn btn-danger" (click)="cancelOrder()"></button>
  </div>
</p-dialog>

<!-- Confirmation Modal for Hold Order -->
<p-dialog header="Confirm Hold" [(visible)]="displayHoldModal" [modal]="true" [style]="{ width: '400px' }">
  <p>Are you sure you want to hold the order?</p>
  <div class="d-flex justify-content-end gap-2">
    <button pButton type="button" label="Cancel" class="btn btn-secondary" (click)="displayHoldModal = false"></button>
    <button pButton type="button" label="Confirm" class="btn btn-info" (click)="holdOrder()"></button>
  </div>
</p-dialog>

<!-- Confirmation Modal for Color Change -->
<p-dialog header="Confirm Color Change" [(visible)]="displayColorChangeModal" [modal]="true" [style]="{ width: '400px' }">
  <p>Are you sure you want to change the color of the item?</p>
  <div class="d-flex justify-content-end gap-2">
    <button pButton type="button" label="Cancel" class="btn btn-secondary" (click)="displayColorChangeModal = false"></button>
    <button pButton type="button" label="Confirm" class="btn btn-success" (click)="acceptColor()"></button>
  </div>
</p-dialog>
